import React, { useState, useEffect } from 'react';
import { FiGlobe, FiSave, FiRefreshCw } from 'react-icons/fi';
import './Admin.css';

const UpdateIP = () => {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchStores();
  }, []);

  const fetchStores = async () => {
    try {
      setLoading(true);
      const response = await fetch('https://doticom.vn:3000/stores');
      if (response.ok) {
        const data = await response.json();
        setStores(data);
      } else {
        console.error('Failed to fetch stores');
      }
    } catch (error) {
      console.error('Error fetching stores:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateStoreIP = async (storeId, formData) => {
    try {
      setLoading(true);
      const response = await fetch('https://doticom.vn:3000/update-ip-addresses', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: storeId,
          ipBep: formData.ipBep,
          ipThuNgan: formData.ipThuNgan,
          ipMayTinh: formData.ipMayTinh,
          ipBanhNgot: formData.ipBanhNgot
        })
      });

      const result = await response.json();
      if (response.ok) {
        alert('Cập nhật IP thành công!');
        fetchStores(); // Refresh data
      } else {
        alert(result.message || 'Có lỗi xảy ra');
      }
    } catch (error) {
      console.error('Error updating IP:', error);
      alert('Có lỗi xảy ra khi cập nhật IP');
    } finally {
      setLoading(false);
    }
  };

  const handleIPUpdate = (storeId, event) => {
    event.preventDefault();
    const formElement = event.target.closest('tr');
    const ipBep = formElement.querySelector('.ip-bep').value.trim();
    const ipThuNgan = formElement.querySelector('.ip-thungan').value.trim();
    const ipMayTinh = formElement.querySelector('.ip-maytinh').value.trim();
    const ipBanhNgot = formElement.querySelector('.ip-banhngot').value.trim();

    if (!ipBep || !ipThuNgan || !ipMayTinh || !ipBanhNgot) {
      alert('Tất cả các trường IP đều bắt buộc.');
      return;
    }

    updateStoreIP(storeId, { ipBep, ipThuNgan, ipMayTinh, ipBanhNgot });
  };

  return (
    <div className="admin-layout">
      <div className="admin-main" style={{ marginLeft: 0 }}>
        <header className="admin-header">
          <div className="header-left">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <FiGlobe size={32} color="#495057" />
              <div>
                <h1>Cập nhật IP</h1>
                <p>Quản lý địa chỉ IP cho các thiết bị trong cửa hàng</p>
              </div>
            </div>
          </div>
          <div className="header-right">
            <button 
              className="btn btn-primary"
              onClick={fetchStores}
              disabled={loading}
            >
              <FiRefreshCw className={loading ? 'spinning' : ''} />
              {loading ? 'Đang tải...' : 'Làm mới'}
            </button>
          </div>
        </header>

        <div className="content-section">
          <div className="card">
            <div className="card-body">
              {loading ? (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Đang tải...</span>
                  </div>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Mã cửa hàng</th>
                        <th>Tên cửa hàng</th>
                        <th>IP Tủ mì</th>
                        <th>IP Thu ngân</th>
                        <th>IP Máy chủ</th>
                        <th>IP Bánh Ngọt</th>
                        <th>Thao tác</th>
                      </tr>
                    </thead>
                    <tbody>
                      {stores.map(store => (
                        <tr key={store.IDCH}>
                          <td>{store.IDCH}</td>
                          <td>{store.MaPB}</td>
                          <td>{store.TenCuaHang}</td>
                          <td>
                            <input
                              type="text"
                              className="form-control ip-bep"
                              defaultValue={store.IpBep || ''}
                              placeholder="192.168.1.100"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control ip-thungan"
                              defaultValue={store.IpThuNgan || ''}
                              placeholder="192.168.1.101"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control ip-maytinh"
                              defaultValue={store.IpMayTinh || ''}
                              placeholder="192.168.1.102"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control ip-banhngot"
                              defaultValue={store.IpBanhNgot || ''}
                              placeholder="192.168.1.103"
                            />
                          </td>
                          <td>
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={(e) => handleIPUpdate(store.IDCH, e)}
                              disabled={loading}
                            >
                              <FiSave className="me-1" />
                              Cập nhật
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateIP;
